/* hs-eslint ignored failing-rules */

import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { oAuthAuthFailed } from '../store/oauth/action-creators';
import GooglePlatform from './GooglePlatform';
const LOG = Logger.getLogger('useLoadGoogleIdentityServices');
export const useLoadGoogleIdentityServices = ({
  onAuthenticationFailed
}) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);
  const [isLoaded, setLoaded] = useState(false);
  useEffect(() => {
    const loadPromise = GooglePlatform.loadGoogleIdentityServices();
    loadPromise.then(hasAlreadyLoaded => {
      setLoaded(hasAlreadyLoaded);
    }).catch(error => {
      setLoaded(false);
      onAuthenticationFailed(error);
      LOG.error('An error occured while loading the google identity services', {
        extra: getSentryExtra(error)
      });
      dispatch(oAuthAuthFailed(error, OAuthProviders.Google));
    }).finally(() => {
      setLoading(false);
    });
  }, [dispatch, onAuthenticationFailed]);
  return {
    isLoading,
    isLoaded
  };
};